export const traderAPI = {
  topups: {
    limits: {
      create(paymentRequisitId: string, paymentChannelId: string, maxTopupsPerDay: number) {
        return `/v1/trader/topups/limits/${paymentRequisitId}/${paymentChannelId}/${maxTopupsPerDay}`
      },
      delete(limitId: string) {
        return `/v1/trader/topups/limits/${limitId}`
      },
    },
  },
}
